import { User } from "../../types/User";
import { handleAction, Action } from "redux-actions";
import { SET_CURRENT_USER } from "./actions";

export interface UserState {
	sessionToken?: string;
	userId?: number;
	user?: User;
}

export const initialUserState: UserState = {
	sessionToken: "",
	userId: -1,
	user: null
};

export const userRedux = handleAction<UserState, UserState>(SET_CURRENT_USER, (state, payload) => {
	return payload.payload;
}, initialUserState);
